import React from "react";
import {
  Box,
  Checkbox,
  TableCell,
  TableRow,
  Typography,
  alpha,
} from "@mui/material";

const cellBaseSx = {
  fontSize: "0.7rem",
  fontWeight: 700,
  p: "8px 8px",
  whiteSpace: "nowrap",
  borderBottom: "2px solid",
  borderBottomColor: "primary.main",
};

const headerBg = (theme) =>
  `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.06)} 0%, ${alpha(theme.palette.primary.light, 0.1)} 100%)`;

const TablaHeader = ({
  columns,
  cargando,
  input,
  orden,
  onSort,
  seleccionable,
  allSelected,
  someSelected,
  onToggleSelectAll,
}) => (
  <TableRow>
    {seleccionable && (
      <TableCell
        sx={{
          ...cellBaseSx,
          background: headerBg,
          p: "4px 6px",
          width: "1%",
          textAlign: "center",
        }}
      >
        <Checkbox
          size="small"
          checked={allSelected}
          indeterminate={someSelected}
          onChange={onToggleSelectAll}
          disabled={cargando}
          sx={{ p: "2px" }}
        />
      </TableCell>
    )}
    <TableCell
      sx={{
        ...cellBaseSx,
        background: headerBg,
        width: "1%",
        borderRight: "1px solid",
        borderRightColor: (t) => alpha(t.palette.primary.main, 0.08),
        textAlign: "center",
        color: "text.disabled",
      }}
    >
      #
    </TableCell>
    {columns.map((col) => (
      <TableCell
        key={col.id}
        align={col.align}
        onClick={() => !cargando && col.ordenable && onSort(col.id)}
        sx={{
          ...cellBaseSx,
          background: headerBg,
          cursor: col.ordenable && !cargando ? "pointer" : "default",
          userSelect: "none",
          color: "text.primary",
          textTransform: "uppercase",
          letterSpacing: "0.6px",
          opacity: cargando ? 0.5 : 1,
          transition: "all 0.2s ease",
          "&:hover":
            col.ordenable && !cargando
              ? {
                  background: (t) =>
                    `linear-gradient(180deg, ${alpha(t.palette.primary.main, 0.12)} 0%, ${alpha(t.palette.primary.light, 0.18)} 100%)`,
                  color: "primary.main",
                }
              : {},
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent:
              col.align === "center"
                ? "center"
                : col.align === "right"
                ? "flex-end"
                : "flex-start",
            gap: 0.5,
          }}
        >
          {col.label}
          {input === col.id && (
            <Typography
              component="span"
              fontSize="0.6rem"
              sx={{
                ml: 0.2,
                color: "primary.main",
                fontWeight: 800,
                bgcolor: (t) => alpha(t.palette.primary.main, 0.1),
                borderRadius: 0.5,
                px: 0.3,
                lineHeight: 1.4,
              }}
            >
              {orden ? "↑" : "↓"}
            </Typography>
          )}
        </Box>
      </TableCell>
    ))}
  </TableRow>
);

export default React.memo(TablaHeader);
